import React from 'react'
import CartComponent from './CartComponent'
import { useParams } from "react-router-dom";
import { LoginContext } from '../../UserContext';
import { useNavigate } from "react-router-dom";
function Cart() {
     const { express } = useParams();
     const { user, login, logout, products, dispatch } =
    React.useContext(LoginContext);
     const navigate = useNavigate();
    let totalAmount = 0
console.log(products,"hello Products" )
  if(products.length>0)
  {
 return (
        <div style={{minHeight:'100vH'}}>

           <div
          className="Login_Header"
          style={{
            background: "#fff",
            paddingInline: 30,
            paddingBlock: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #ddd",
         
          }}
        >
        <h1 
        onClick={()=>{ navigate(`/`);} }
        style={{
            position:'absolute',
            left:50
        }}>
            🔙
        </h1>
        
       
        {express===true ?
          <h4
          
            style={{
              fontSize: "2.3em",
              color: "black",
              marginBlock: "0.5em",
            }}
          >
         
        Express Cart
          </h4>
          : <h4
          
            style={{
              fontSize: "2.3em",
              color: "black",
              marginBlock: "0.5em",
            }}
          >
         
        Your Cart
          </h4> }
        

        </div>
        <div className='Cart' style={{padding:20,minHeight:'80vH' }}>
        {products.map((element,index)  =>{
                totalAmount+=element.price*element.count ;
            return(  <CartComponent key={index} id={element.id} name={element.title} count={element.count} image={element.image}    />)
           
        }  )}
           
            
        </div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',  marginTop:'auto' ,paddingBlock:6 ,borderTopWidth:1,borderTopColor:'#ddd',   borderTopStyle: 'solid',
    width: '100%',background:'#fff'  }} className="Cart_footer">
    <div style={{marginLeft:'2%' }}>
    <p style={{marginBlock:3,color:'black',fontWeight:'bold',fontSize:25  }}> Rs {totalAmount}</p>
    <text style={{color:'#2874f0'}}>Proceed to confirm order </text> 
 </div>
      <div onClick={() =>{navigate('/orderDetail')} } style={{display:'flex', marginRight:'2%',backgroundColor:'#fb641b',padding:'1%',color:'white',fontSize:16,fontWeight:'bold' }}>
            Place Order
        </div>
        </div>

      
        </div>
    )
  }
  else
  {
      return(
          <div style={{display:'flex',flexDirection:'column',alignItems:'center' }}>
            <div
          className="Login_Header"
          style={{
            background: "#fff",
            paddingInline: 30,
            paddingBlock: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #ddd",
         
          }}
        >
        <h1 
        onClick={()=>{ navigate(`/`);} }
        style={{
            position:'absolute',
            left:'1%'
        }}>
            🔙
        </h1>
        
       
        {express === true ?
          <h4
          
            style={{
              fontSize: "2.3em",
              color: "black",
              marginBlock: "0.5em",
            }}
          >
         
        Express Cart
          </h4>
          : <h4
          
            style={{
              fontSize: "2.3em",
              color: "black",
              marginBlock: "0.5em",
            }}
          >
         
        Your Cart
          </h4> }
        

        </div>
        <div style={{display:'flex',flexDirection:'column',alignItems:'center' }}>
            <img
            src="https://res.cloudinary.com/mela-techologies-inc/image/upload/v1641499183/Namaste%20/images/Cart_qmpaur.png"
            width="50%"
            height="350"
            style={{
                objectFit:'contain',
                marginTop:50
            }}
          />
          <h1 style={{marginLeft:10,marginTop:0 }}> Your Cart is empty</h1>
        </div>
        </div>
      )
  }
   
}

export default Cart
